import * as tslib_1 from "tslib";
import { Event } from "./Event";
var ProgressEvent = (function (_super) {
    tslib_1.__extends(ProgressEvent, _super);
    function ProgressEvent(type, bubbles, cancelable, byteLoaded, bytesTotal) {
        if (bubbles === void 0) { bubbles = true; }
        if (cancelable === void 0) { cancelable = false; }
        if (byteLoaded === void 0) { byteLoaded = 0; }
        if (bytesTotal === void 0) { bytesTotal = 0; }
        var _this = _super.call(this, type, bubbles, cancelable) || this;
        _this._byteLoaded = byteLoaded;
        _this._bytesTotal = bytesTotal;
        return _this;
    }
    Object.defineProperty(ProgressEvent.prototype, "bytesTotal", {
        get: function () {
            return this._bytesTotal;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProgressEvent.prototype, "bytesLoaded", {
        get: function () {
            return this._byteLoaded;
        },
        enumerable: true,
        configurable: true
    });
    ProgressEvent.prototype.clone = function () {
        return new ProgressEvent(this.type, null, null, this._byteLoaded, this._bytesTotal);
    };
    return ProgressEvent;
}(Event));
export { ProgressEvent };
ProgressEvent.PROGRESS = "progress";
ProgressEvent.SOCKET_DATA = "socketData";
ProgressEvent.STANDARD_ERROR_DATA = "standardErrorData";
ProgressEvent.STANDARD_OUTPUT_DATA = "standardOutputData";
